export default "/_next/static/chunks/fonts/lato-900-4b21d625362d4f7d84d2cb0f1ce38fb7.woff2";